import { clsx } from 'clsx';
import { FC } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { Body } from 'atoms/Typography/Typography';
import { IActionButton } from './types';
import styles from './styles.module.css';

export const ActionButton: FC<IActionButton> = ({
  text,
  action,
  icon = 'arrowLeft',
  classes,
}) => {
  return (
    <div className={clsx(styles.root, classes?.root)} onClick={action}>
      <IconSVG type={icon} className={clsx(styles.icon, classes?.icon)} />
      <Body
        type="md"
        weight="medium"
        tag="span"
        className={clsx(styles.text, classes?.text)}
      >
        {text}
      </Body>
    </div>
  );
};
